module.exports = __webpack_public_path__ + "img/categories-3.a2587875.jpg";